var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNexus = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 33 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nexus_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "nexus_svg__b",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: -1,
  width: 33,
  height: 33
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32.89-.01H.37v32h32.52v-32Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#nexus_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.23 9.05 2.64 4.47 1.21 5.89l4.59 4.59 1.43-1.43ZM9.58 6.69 4.99 2.11 3.57 3.53l4.58 4.59 1.43-1.43ZM1.8 25.69l4.57-4.59-1.41-1.42-4.59 4.58 1.43 1.43ZM4.15 28.04l4.59-4.59-1.43-1.46-4.59 4.62 1.43 1.43ZM26.87 21.73l4.59 4.58 1.43-1.42-4.59-4.59-1.43 1.43ZM24.52 24.09l4.59 4.58 1.42-1.42-4.58-4.59-1.43 1.43Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.37 8.32a15.94 15.94 0 0 0-.82 13.6l1.6-1.6a13.89 13.89 0 0 1 .73-10.51L2.37 8.32ZM32.37 15.99a15.89 15.89 0 0 0-2.19-8L28.7 9.47a13.89 13.89 0 0 1 .9 11l1.6 1.6a15.942 15.942 0 0 0 1.17-6.08Z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m28.6.48 3.4 3.3L3.37 31.5l-3.41-3.3L28.6.48Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.37 1.99a13.85 13.85 0 0 1 6.26 1.5l1.52-1.5a16.08 16.08 0 0 0-17 .92l1.48 1.45a13.93 13.93 0 0 1 7.74-2.37ZM16.37 29.99a13.82 13.82 0 0 1-7.21-2l-1.48 1.48a16.08 16.08 0 0 0 19.2-1.36l-1.43-1.44a13.88 13.88 0 0 1-9.08 3.32ZM17.36 8.78h-5.22l-4.17 7.2.8 1.39 8.59-8.59ZM13.95 23.19h6.51l4.16-7.21-1.27-2.19-9.4 9.4Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "nexus_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32.88v31.95H0z"
})))));
export default SvgNexus;